/* VÉLOIR — Maison theme scripts. No dependencies. */
(function () {
  'use strict';

  var theme = window.theme || { routes: {} };

  /* ---------- Money ---------- */
  function formatMoney(cents) {
    var format = theme.moneyFormat || '${{amount}}';
    var value = (Number(cents) || 0) / 100;
    function withDelimiters(n, decimals, thousands, decimal) {
      var parts = n.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimals ? decimal : '');
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return withDelimiters(value, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelimiters(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelimiters(value, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return withDelimiters(value, 2, "'", '.');
        default: return withDelimiters(value, 2, ',', '.');
      }
    });
  }

  /* ---------- Announcement rotation ---------- */
  function initAnnouncement() {
    var track = document.querySelector('[data-announcement]');
    if (!track) return;
    var items = track.children;
    if (items.length < 2) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var i = 0;
    setInterval(function () {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 4500);
  }

  /* ---------- Header ---------- */
  function initHeader() {
    var header = document.querySelector('[data-header]');
    if (!header) return;
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 8); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    var drawer = header.querySelector('[data-menu]');
    var opener = header.querySelector('[data-menu-open]');
    if (!drawer || !opener) return;

    function open() {
      drawer.hidden = false;
      header.classList.add('is-menu-open');
      opener.setAttribute('aria-expanded', 'true');
      document.documentElement.style.overflow = 'hidden';
      var first = drawer.querySelector('a, button');
      if (first) first.focus();
    }
    function close() {
      drawer.hidden = true;
      header.classList.remove('is-menu-open');
      opener.setAttribute('aria-expanded', 'false');
      document.documentElement.style.overflow = '';
      opener.focus();
    }
    opener.addEventListener('click', open);
    drawer.querySelectorAll('[data-menu-close]').forEach(function (el) { el.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !drawer.hidden) close(); });
  }

  /* ---------- Quantity steppers ---------- */
  function initQuantity(scope) {
    (scope || document).querySelectorAll('.qty').forEach(function (qty) {
      if (qty.dataset.bound) return;
      qty.dataset.bound = '1';
      var input = qty.querySelector('input');
      qty.querySelectorAll('[data-qty]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var min = parseInt(input.min || '0', 10);
          var next = Math.max(min, (parseInt(input.value, 10) || 0) + parseInt(btn.dataset.qty, 10));
          input.value = next;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* ---------- Cart count ---------- */
  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
    document.querySelectorAll('.header__cart').forEach(function (el) {
      el.setAttribute('aria-label', 'Bag, ' + count + (count === 1 ? ' item' : ' items'));
    });
  }

  function esc(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function sizedImage(url, width) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  /* ---------- Cart drawer ---------- */
  var CartDrawer = {
    el: null,
    lastFocus: null,
    init: function () {
      this.el = document.querySelector('[data-cart-drawer]');
      if (!this.el) return;
      var self = this;
      this.el.querySelectorAll('[data-cart-close]').forEach(function (b) { b.addEventListener('click', function () { self.close(); }); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !self.el.hidden) self.close(); });
      document.querySelectorAll('[data-cart-open]').forEach(function (link) {
        link.addEventListener('click', function (e) {
          if (!theme.cartDrawer || document.body.classList.contains('template-cart')) return;
          e.preventDefault();
          self.open();
        });
      });
      this.el.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-line]');
        if (!btn) return;
        var line = parseInt(btn.dataset.line, 10);
        var qty = parseInt(btn.dataset.qtyTarget, 10);
        self.change(line, qty);
      });
    },
    open: function (cart) {
      if (!this.el) { window.location.href = theme.routes.cart || '/cart'; return; }
      this.lastFocus = document.activeElement;
      this.el.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      this.el.querySelector('.cart-drawer__panel').focus();
      if (cart) this.render(cart); else this.refresh();
    },
    close: function () {
      if (!this.el) return;
      this.el.hidden = true;
      document.documentElement.style.overflow = '';
      if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
    },
    refresh: function () {
      var self = this;
      return fetch((theme.routes.cart || '/cart') + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { self.render(cart); return cart; });
    },
    change: function (line, quantity) {
      var self = this;
      this.el.classList.add('is-busy');
      return fetch((theme.routes.cartChange || '/cart/change') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) { self.render(cart); })
        .catch(function () { self.refresh(); })
        .finally(function () { self.el.classList.remove('is-busy'); });
    },
    render: function (cart) {
      if (!this.el) return;
      updateCartCount(cart.item_count);
      var body = this.el.querySelector('[data-cart-drawer-body]');
      var foot = this.el.querySelector('[data-cart-drawer-foot]');
      var count = this.el.querySelector('[data-cart-drawer-count]');
      count.textContent = cart.item_count ? '(' + cart.item_count + ')' : '';

      // Free-shipping meter
      var meter = this.el.querySelector('[data-ship-meter]');
      if (meter && theme.freeShipping > 0) {
        var remaining = theme.freeShipping - cart.total_price;
        var pct = Math.min(100, Math.round((cart.total_price / theme.freeShipping) * 100));
        meter.querySelector('[data-ship-fill]').style.width = pct + '%';
        meter.querySelector('[data-ship-text]').innerHTML = remaining > 0
          ? 'You are <strong>' + esc(formatMoney(remaining)) + '</strong> away from complimentary shipping.'
          : '<strong>Complimentary shipping</strong> is yours. Merci.';
        meter.hidden = cart.item_count === 0;
      }

      if (!cart.item_count) {
        body.innerHTML = '<div class="cart-drawer__empty"><p class="display">Your bag is resting.</p>' +
          '<p>Take your time — have a look around the house.</p>' +
          '<a href="' + esc(theme.routes.allProducts || '/collections/all') + '" class="button button--primary">Continue shopping</a></div>';
        foot.hidden = true;
        return;
      }

      var html = '<ul class="cart__items" role="list">';
      cart.items.forEach(function (item, i) {
        var line = i + 1;
        var variant = item.variant_title && item.variant_title !== 'Default Title' ? '<p class="cart-item__variant">' + esc(item.variant_title) + '</p>' : '';
        var price = item.original_line_price > item.final_line_price
          ? '<s class="price__compare">' + esc(formatMoney(item.original_line_price)) + '</s><span>' + esc(formatMoney(item.final_line_price)) + '</span>'
          : '<span>' + esc(formatMoney(item.final_line_price)) + '</span>';
        html += '<li class="cart-item">' +
          '<a href="' + esc(item.url) + '" class="cart-item__media" tabindex="-1" aria-hidden="true">' +
            (item.image ? '<img src="' + esc(sizedImage(item.image, 240)) + '" alt="" loading="lazy">' : '') +
          '</a>' +
          '<div class="cart-item__info">' +
            '<a href="' + esc(item.url) + '" class="cart-item__title">' + esc(item.product_title) + '</a>' + variant +
            '<div class="cart-item__row">' +
              '<div class="qty qty--small">' +
                '<button type="button" class="qty__btn" data-line="' + line + '" data-qty-target="' + (item.quantity - 1) + '" aria-label="Decrease quantity of ' + esc(item.product_title) + '">−</button>' +
                '<span class="qty__value" aria-label="Quantity">' + item.quantity + '</span>' +
                '<button type="button" class="qty__btn" data-line="' + line + '" data-qty-target="' + (item.quantity + 1) + '" aria-label="Increase quantity of ' + esc(item.product_title) + '">+</button>' +
              '</div>' +
              '<button type="button" class="link-button" data-line="' + line + '" data-qty-target="0">Remove</button>' +
            '</div>' +
          '</div>' +
          '<div class="cart-item__price">' + price + '</div>' +
        '</li>';
      });
      html += '</ul>';
      body.innerHTML = html;
      this.el.querySelector('[data-cart-drawer-subtotal]').textContent = formatMoney(cart.total_price);
      foot.hidden = false;
    }
  };

  /* Adds one or more items, then opens the bag (or goes to /cart if the drawer is off). */
  function addToCart(body, isJson) {
    return fetch((theme.routes.cartAdd || '/cart/add') + '.js', {
      method: 'POST',
      headers: isJson ? { 'Content-Type': 'application/json', Accept: 'application/json' } : { Accept: 'application/json' },
      body: body
    })
      .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
      .then(function (result) {
        if (!result.ok) throw new Error(result.data.description || result.data.message || 'Could not add to bag');
        if (theme.cartDrawer && CartDrawer.el) {
          return CartDrawer.refresh().then(function (cart) { CartDrawer.open(cart); });
        }
        window.location.href = theme.routes.cart || '/cart';
      });
  }

  /* ---------- Quick add on product cards ---------- */
  function initQuickAdd() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-quick-add]');
      if (!btn || btn.disabled) return;
      e.preventDefault();
      btn.classList.add('is-loading');
      addToCart(JSON.stringify({ items: [{ id: Number(btn.dataset.quickAdd), quantity: 1 }] }), true)
        .catch(function (err) { btn.title = err.message; })
        .finally(function () { btn.classList.remove('is-loading'); });
    });
  }

  /* ---------- Dialogs (size guide) ---------- */
  function initDialogs() {
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-dialog-open]');
      if (opener) {
        var dlg = document.getElementById(opener.dataset.dialogOpen);
        if (dlg && dlg.showModal) { dlg.showModal(); }
        return;
      }
      var closer = e.target.closest('[data-dialog-close]');
      if (closer) { closer.closest('dialog').close(); return; }
      if (e.target.tagName === 'DIALOG') e.target.close(); // click on backdrop
    });
  }

  /* ---------- Product page ---------- */
  function initProduct(section) {
    var jsonEl = section.querySelector('[data-product-json]');
    if (!jsonEl) return;
    var product;
    try { product = JSON.parse(jsonEl.textContent); } catch (e) { return; }

    var form = section.querySelector('.buy__form');
    var idInput = section.querySelector('[data-variant-id]');
    var addBtn = section.querySelector('[data-add-button]');
    var addLabel = section.querySelector('[data-add-label]');
    var priceEl = section.querySelector('[data-price-current]');
    var compareEl = section.querySelector('[data-price-compare]');
    var priceWrap = section.querySelector('.product__price .price');
    var picker = section.querySelector('[data-variant-picker]');
    var errorEl = section.querySelector('[data-form-error]');
    var sticky = section.querySelector('[data-sticky-buy]');
    var stickyAdd = section.querySelector('[data-sticky-add]');
    var stickyPrice = section.querySelector('[data-sticky-price]');

    if (sticky && addBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        // Show once the main button has scrolled above the viewport
        sticky.hidden = e.isIntersecting || e.boundingClientRect.top > 0;
      }).observe(addBtn);
    }

    function selectedOptions() {
      var values = [];
      picker.querySelectorAll('fieldset').forEach(function (fs, i) {
        var checked = fs.querySelector('input:checked');
        values[i] = checked ? checked.value : null;
      });
      return values;
    }

    function findVariant(values) {
      return product.variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === values[i]; });
      });
    }

    function markAvailability(values) {
      // Cross out values that have no available variant given the other selections.
      picker.querySelectorAll('fieldset').forEach(function (fs, index) {
        fs.querySelectorAll('input').forEach(function (input) {
          var test = values.slice();
          test[index] = input.value;
          var match = product.variants.find(function (v) {
            return v.available && v.options.every(function (opt, i) { return test[i] === null || opt === test[i]; });
          });
          var label = fs.querySelector('label[for="' + input.id + '"]');
          if (label) label.classList.toggle('is-unavailable', !match);
        });
      });
    }

    function onChange() {
      var values = selectedOptions();
      picker.querySelectorAll('[data-option-value]').forEach(function (el) {
        el.textContent = values[parseInt(el.dataset.optionValue, 10)] || '';
      });
      markAvailability(values);
      var variant = findVariant(values);

      if (!variant) {
        addBtn.disabled = true;
        addLabel.textContent = 'Unavailable';
        return;
      }
      idInput.value = variant.id;
      addBtn.disabled = !variant.available;
      addLabel.textContent = variant.available ? 'Add to bag' : 'Sold out';
      if (stickyAdd) {
        stickyAdd.disabled = !variant.available;
        stickyAdd.textContent = variant.available ? 'Add to bag' : 'Sold out';
      }
      if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);

      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (compareEl) {
        var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        compareEl.hidden = !onSale;
        compareEl.textContent = onSale ? formatMoney(variant.compare_at_price) : '';
        if (priceWrap) priceWrap.classList.toggle('price--sale', !!onSale);
      }

      if (variant.featured_media) {
        var item = section.querySelector('[data-media-id="' + variant.featured_media.id + '"]');
        if (item) {
          var list = item.parentElement;
          if (window.matchMedia('(max-width: 989px)').matches) {
            list.scrollTo({ left: item.offsetLeft - list.offsetLeft, behavior: 'smooth' });
          } else if (item !== list.firstElementChild) {
            list.insertBefore(item, list.firstElementChild);
          }
        }
      }

      if (window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    if (picker) {
      picker.addEventListener('change', onChange);
      markAvailability(selectedOptions());
    }

    // Gallery dots on mobile
    var mediaList = section.querySelector('.product__media-list');
    var dots = section.querySelectorAll('.product__dot');
    if (mediaList && dots.length) {
      mediaList.addEventListener('scroll', function () {
        var index = Math.round(mediaList.scrollLeft / mediaList.clientWidth);
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === index); });
      }, { passive: true });
    }

    // Ajax add to bag
    if (form && window.fetch) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (addBtn.disabled) return;
        var original = addLabel.textContent;
        addBtn.disabled = true;
        addLabel.textContent = 'Adding…';
        if (errorEl) errorEl.hidden = true;

        addToCart(new FormData(form), false)
          .catch(function (err) {
            if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
          })
          .finally(function () {
            addBtn.disabled = false;
            addLabel.textContent = original === 'Adding…' ? 'Add to bag' : original;
          });
      });
    }
  }

  /* ---------- Recommendations ---------- */
  function initRecommendations() {
    document.querySelectorAll('[data-recommendations]').forEach(function (el) {
      if (!el.dataset.url || !window.fetch) return;
      fetch(el.dataset.url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-recommendations]');
          if (fresh && fresh.innerHTML.trim()) {
            el.innerHTML = fresh.innerHTML;
          }
        })
        .catch(function () {});
    });
  }

  /* ---------- Cart page ---------- */
  function initCart() {
    var form = document.querySelector('[data-cart-form]');
    if (!form) return;
    var timer;
    form.addEventListener('change', function (e) {
      if (!e.target.matches('[data-cart-qty]')) return;
      clearTimeout(timer);
      timer = setTimeout(function () {
        var hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.name = 'update';
        hidden.value = '1';
        form.appendChild(hidden);
        form.submit();
      }, 500);
    });
  }

  /* ---------- Collection sorting ---------- */
  function initSort() {
    var select = document.querySelector('[data-sort-select]');
    if (!select) return;
    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* ---------- Reveal on scroll ---------- */
  function initReveal() {
    var els = document.querySelectorAll('.reveal');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  function init() {
    initAnnouncement();
    initHeader();
    initQuantity();
    CartDrawer.init();
    initQuickAdd();
    initDialogs();
    document.querySelectorAll('[data-product]').forEach(initProduct);
    initRecommendations();
    initCart();
    initSort();
    initReveal();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Re-initialise when sections are edited in the theme editor
  document.addEventListener('shopify:section:load', function (e) {
    initQuantity(e.target);
    e.target.querySelectorAll('[data-product]').forEach(initProduct);
    e.target.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-visible'); });
  });
})();
